import styled, { css } from 'styled-components';

interface IButtonProps {
  svgWhiteBackground: boolean;
  svgRadius: boolean;
  disabled: boolean;
}

export const Button = styled.button<IButtonProps>`
  display: flex;
  justify-content: center;
  gap: 8px;
  align-items: center;
  justify-content: center;

  font-weight: 700;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.gray[100]};

  border-radius: 8px;
  background-color: ${({ theme, disabled, color }) =>
    !disabled
      ? color
        ? color
        : theme.colors.orange.primary
      : theme.colors.gray[500]};
  border: none;
  padding: 0 35px;

  transition: 0.2s ease;

  height: 48px;
  min-width: 196px;
  min-height: 48px;

  .arrow {
    display: flex;
    align-items: center;
    background-color: ${({ theme }) => theme.colors.white};
    border-radius: 10px;
  }

  &:hover {
    opacity: 0.8;
  }

  svg {
    ${(props) =>
      props.svgWhiteBackground &&
      css`
        color: ${({ theme }) =>
          !props.disabled
            ? props.color
              ? theme.colors.secondary
              : theme.colors.orange.primary
            : theme.colors.gray[500]};
        background: ${({ theme }) => theme.colors.white};
      `}

    ${(props) =>
      props.svgRadius &&
      css`
        border-radius: 50%;
        padding: 1px;
      `}
  }
`;
